/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	OrganisationPrivacyShowPathParams,
	OrganisationPrivacyShowResponse,
} from '../types/OrganisationPrivacyShow'

/**
 * GET /organisations/:organisation/privacy
 * @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationPrivacyController.php OrganisationPrivacyController::show
 */
export async function organisationPrivacyShow(
	organisation: OrganisationPrivacyShowPathParams['organisation'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganisationPrivacyShowResponse>> {
	return axiosInstance.get(`/organisations/${organisation}/privacy`, config)
}
